import api from './api';

/** Antwort von GET /api/health/services (authentifiziert). */
export interface HealthStatus {
  status: string;
  dryRun: boolean;
  /** LinkedIn-Testmodus (LINKEDIN_DRY_RUN, sonst wie dryRun). */
  linkedInDryRun?: boolean;
  /** Testmodus je Plattform (INSTAGRAM_/X_/FACEBOOK_DRY_RUN, sonst wie dryRun). */
  instagramDryRun?: boolean;
  xDryRun?: boolean;
  facebookDryRun?: boolean;
  /** Je Dienst 'configured' | 'not_configured' (database: 'ok'). */
  services: Record<string, string>;
}

class SystemService {
  // /health kennt weder services noch dryRun -- erst /health/services
  // liefert beides (hinter der Auth, weil dort der Schluessel-Status steht).
  async getHealth(): Promise<HealthStatus> {
    const response = await api.get('/health/services');
    return response.data;
  }
}

const systemService = new SystemService();
export default systemService;
